var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"local-preloader"},[_c('div',{staticClass:"lds-dual-ring",class:{'lds-dual-ring__mini': _vm.mini}})])}
var staticRenderFns = []

export { render, staticRenderFns }